import React, { useEffect, useState } from "react";
// import { BrowserRouter as Route, Routes, Router } from "react-router-dom";
import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import {
  CircularProgress,
} from "@mui/material"

import { SnackbarProvider, useSnackbar } from 'notistack';

import HomePage from "./pages/HomePage";
import NanoComp from "./pages/NanoComp";
import MyNanoComp from "./pages/MyNanoComp";
import MyStudies from "./pages/MyStudies";
import DiscussionBoard from "./pages/DiscussionBoard";
import NotificationsList from "./pages/NotificationsList";

import LoginActions from "./components/LoginActions";

import NavBar from "./components/NavBar";
import NanoCompVisualiser from "./components/NanoCompVisualiser";

import { ThemeProvider, createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "montserrat",
      textTransform: "none",
      fontSize: 16,
    },
  },
});

const App = () => {

  // const [isLogged, setIsLogged] = useState(false);
  const firebase = useSelector(state => state.firebase);

  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   if(auth != undefined) {
  //     setIsLogged(true)
  //   } else {
      
  //   }
  // })
  // console.log(firebase.auth)
  // console.log(firebase)
// useEffect(() => {
//   if(firebase.auth.isEmpty == false) {
//   setIsLogged(true)
// }
// if(firebase.auth.isEmpty == true) {
//   setIsLogged(false)
// }
// },[firebase.auth.isEmpty])

  // firebase.auth((user) => {
  //   if (user) {
  //     setIsLogged(true);
  //     console.log("logged")
  //   } else {
  //     setIsLogged(false);
  //     console.log("no loggy")

  //   }
  // });
  // console.log(firebase.auth.isEmpty)

  return (
    <>
    <ThemeProvider theme={theme}>
    <SnackbarProvider 
      maxSnack={3}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      autoHideDuration={2000}
    >

    <BrowserRouter>

        <NavBar />
          <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginActions />} />
            {firebase.auth.isEmpty == false ? (
              <>
            <Route path="/nanocompetencies" element={<NanoComp />} />
            <Route path="/nanocontent" element={<NanoCompVisualiser />} />
            {/* <Route path="/mycompetencies" element={<MyNanoComp />} /> */}
            <Route path="/mystudies" element={<MyStudies />} />
            <Route path="/discussion" element={<DiscussionBoard />} />
            <Route path="/notifications" element={<NotificationsList />} />
            </>
            ) : (
              <>
            <Route path="/nanocompetencies"  element={<Navigate to="/" />} />
            <Route path="/nanocontent" element={<Navigate to="/" />} />
            {/* <Route path="/mycompetencies" element={<Navigate to="/" />} /> */}
            <Route path="/mystudies" element={<Navigate to="/" />} />
            <Route path="/discussion" element={<Navigate to="/" />} />
            <Route path="/notifications" element={<Navigate to="/" />} />
            </>
            )}
          </Routes>
          </BrowserRouter>
          </SnackbarProvider>
    </ThemeProvider>
    </>
  );
}

export default App;
